var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconGg = function SvgIconGg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M23.898 10.435H13.565V.102a12.1 12.1 0 0 0-3.13 0v10.333H.102a12.1 12.1 0 0 0 0 3.13h10.333v10.333a12.1 12.1 0 0 0 3.13 0V13.565h10.333a12.1 12.1 0 0 0 0-3.13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "m15.391 12.522.783.521v-2.086l-.783.521h-2.87v-2.87l.522-.782h-2.086l.521.783v2.87h-2.87l-.782-.522v2.086l.783-.521h2.87v2.87l-.522.782h2.086l-.521-.783v-2.87z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconGg;